import React, { useContext, useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import { loginUser, signUpUser } from '../services/authServices';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { toast } from 'react-toastify';
import { loginAdmin } from '../services/adminServices';

const MemoizedParticles = React.memo(Particles);

const AdminLogin = () => {
  const { login, setLogin } = useContext(AppContext);
  const [user, setUser] = useState({ username: "", userPassword: "" });
  const [error, setError] = useState(null);
  const [cssLoaded, setCssLoaded] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    const result = await loginAdmin(user);
    if (result.success) {
      setLogin({ ...login, isLogin: true, token: result.token, user: result.user, userRole: 1 });
      localStorage.setItem("token", result.token);
      localStorage.setItem("userRole", 1);
      navigate('/admin/');
    } else {
      setError(result.error);
    }
  };

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    });
  }, []);

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "./assets/css/login.css";
    link.onload = () => {
      setCssLoaded(true);
    };
    document.head.appendChild(link);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  useEffect(() => {
    if (login.isLogin && login.userRole) navigate("/admin/");
  }, [login]);

  const particlesOptions = useMemo(() => ({
    fpsLimit: 120,
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "repulse",
        },
        resize: true,
      },
      modes: {
        push: {
          quantity: 4,
        },
        repulse: {
          distance: 100,
          duration: 0.4,
        },
      },
    },
    particles: {
      color: {
        value: "#9bf51a",
      },
      links: {
        color: "#9bf51a",
        distance: 150,
        enable: true,
        opacity: 1,
        width: 1,
      },
      move: {
        direction: "none",
        enable: true,
        outModes: {
          default: "bounce",
        },
        random: false,
        speed: 4,
        straight: false,
      },
      number: {
        density: {
          enable: true,
          area: 500,
        },
        value: 500,
      },
      opacity: {
        value: 0.5,
      },
      shape: {
        type: "circle",
      },
      size: {
        value: { min: 1, max: 5 },
      },
    },
    detectRetina: true,
  }), []);

  return (
    <>
      {cssLoaded && <section className="login_wrapper d-flex align-items-center">
        <div className="container">
          <div className="row g-0 justify-content-center">
            <div className="col-lg-4 p-0">
              <div className="login-wrap text-center">
                <img src={"/assets/images/logo.png"} style={{ "width": "200px" }} alt="logo" />
                <h2>Log in</h2>
                <form id="login-form" onSubmit={handleLogin}>
                  <div className="user-name">
                    <input type="text" name="username" id="username" onChange={(e) => { setUser({ ...user, "username": e.target.value }) }} placeholder="Username" />
                  </div>
                  <div className="password mt-3">
                    <input type="password" name="userPassword" id="userPassword" onChange={(e) => { setUser({ ...user, "userPassword": e.target.value }) }} placeholder="Password" />
                  </div>
                  {/* <div className="forgot-password">
                    <a onClick={() => { }}>Forgot Password?</a>
                  </div> */}
                  <div className="login-form-btn mt-5">
                    <button type="submit" style={{ border: "none" }} onClick={handleLogin} className="form-btn submit">LOG IN</button>
                    <div className='mt-3' style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                      {error && <div><span id="ferror" className="alert alert-danger p-1 mt-3 fw-semibold" role="alert">
                        {error}
                      </span></div>}
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {/* <div className="col-lg-4 p-0">
              <div className="grow-wrap text-center d-flex flex-column justify-content-center">
                <h2 className="mt-5 mb-4">Grow with Us !</h2>
                <p>To keep connected with us please login with your personal info</p>
                <div className="sign-us mt-5">
                  <a className="form-btn">{"SIGN UP"}</a>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div id='particles-js'>
          <MemoizedParticles
            id="tsparticles"
            options={particlesOptions}
          />
        </div>
      </section>}
    </>
  )
}

export default AdminLogin;